/* globals google */
'use strict';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var activeMarker;
    var map;
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(37.09024, -95.712891);
    var mapOptions = {
        scrollwheel: false,
        zoom: 5,
        center: latlng,
        styles: [
            {
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#f5f5f5'
                    }
                ]
            },
            {
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#616161'
                    }
                ]
            },
            {
                elementType: 'labels.text.stroke',
                stylers: [
                    {
                        color: '#f5f5f5'
                    }
                ]
            },
            {
                featureType: 'administrative.land_parcel',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#bdbdbd'
                    }
                ]
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#eeeeee'
                    }
                ]
            },
            {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#757575'
                    }
                ]
            },
            {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#e5e5e5'
                    }
                ]
            },
            {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#9e9e9e'
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#ffffff'
                    }
                ]
            },
            {
                featureType: 'road.arterial',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#757575'
                    }
                ]
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#dadada'
                    }
                ]
            },
            {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#616161'
                    }
                ]
            },
            {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#9e9e9e'
                    }
                ]
            },
            {
                featureType: 'transit.line',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#e5e5e5'
                    }
                ]
            },
            {
                featureType: 'transit.station',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#eeeeee'
                    }
                ]
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#c9c9c9'
                    }
                ]
            },
            {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        color: '#9e9e9e'
                    }
                ]
            }
        ]
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');
    var resultsLength = $('.store-details-page-container').length === 1 ? 1 : 2;

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // Customized google map marker icon with svg format
    var markerImg = {
        path: resultsLength > 1 ? 'M24.6519 13.7063C24.6519 22.0347 12.4588 30.9404 12.4588 30.9404C12.4588 30.9404 0.265625 22.0347 0.265625 13.7063C0.265625 5.37796 5.72468 0.780762 12.4588 0.780762C19.1929 0.780762 24.6519 5.37796 24.6519 13.7063Z'
            : 'M23 12.1908C23 20.0457 11.5 28.4451 11.5 28.4451C11.5 28.4451 0 20.0457 0 12.1908C0 4.33586 5.14873 0 11.5 0C17.8513 0 23 4.33586 23 12.1908Z',
        fillColor: resultsLength > 1 ? '#111' : '#789DDB',
        strokeColor: resultsLength > 1 ? '#111' : '#789DDB',
        fillOpacity: 1,
        scale: 1.1,
        strokeWeight: 2,
        anchor: new google.maps.Point(13, 30),
        labelOrigin: new google.maps.Point(12, 12)
    };

    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var lable = parseInt(key, 10) + 1;
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerImg,
            label: resultsLength > 1 ? { text: lable.toString(), color: 'white', fontSize: '14px', fontWeight: '700' }
                : { text: lable.toString(), color: '#00000000', fontSize: '14px', fontWeight: '700' }
        });


        var changeIconColor = function (fillColor) {
            return {
                path: 'M24.6519 13.7063C24.6519 22.0347 12.4588 30.9404 12.4588 30.9404C12.4588 30.9404 0.265625 22.0347 0.265625 13.7063C0.265625 5.37796 5.72468 0.780762 12.4588 0.780762C19.1929 0.780762 24.6519 5.37796 24.6519 13.7063Z',
                fillColor: fillColor,
                fillOpacity: 1,
                strokeColor: fillColor,
                scale: 1.1,
                strokeWeight: 2,
                anchor: new google.maps.Point(13, 30),
                labelOrigin: new google.maps.Point(12, 12)
            };
        };


        if ($(window).innerWidth() > 992) {
            marker.addListener('click', function () {
                if (activeMarker) {
                    activeMarker.setIcon(changeIconColor('#111'));
                }
                marker.setIcon(changeIconColor('#789ddb'));
                activeMarker = marker;

                $('.store-result').removeClass('selected-store-result');
                var $resultParentContainer = $('.store-locator-results-container');
                var $resultDivName = $resultParentContainer.find('.location-name:contains(' + item.name + ')');
                $resultDivName.closest('.store-result').addClass('selected-store-result');
                $resultDivName.get(0).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
            });
        } else {
            marker.addListener('click', function () {
                if (activeMarker) {
                    activeMarker.setIcon(changeIconColor('#111'));
                }
                marker.setIcon(changeIconColor('#789ddb'));
                activeMarker = marker;

                infowindow.setOptions({
                    content: item.infoWindowHtml,
                    maxWidth: 300
                });
                infowindow.open(map, marker);

                $('.store-result').removeClass('selected-store-result');
                var $resultParentContainer = $('.store-locator-results-container');
                var $resultDivName = $resultParentContainer.find('.location-name:contains(' + item.name + ')');
                $resultDivName.closest('.store-result').addClass('selected-store-result');
            });
        }


        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
    google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
        if (this.getZoom() > 15) {
            this.setZoom(15);
        }
    });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').removeClass('d-none');
        $('.status-message').removeClass('d-none');
        $('.distance-messaging').addClass('text-danger');
    } else {
        $('.store-locator-no-results').addClass('d-none');
        $('.status-message').removeClass('d-none');
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        $('.store-locator-content-asset-container').addClass('d-none');
        $('.map-container').addClass('d-lg-block');
        $('.bopis-callout-slot').removeClass('d-flex').addClass('d-none');
        $('.results-card-container').removeClass('d-none');
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
    if (data.statusHtml) {
        $('.results-status-container').html(data.statusHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };
    var findInStore = $('.in-store-pickup-checkbox').is(':checked');

    if ($('.near-by-instore-pickup-btn').length === 1) {
        findInStore = true;
    }

    urlParams = { radius: radius, findInStore: findInStore, postalCode: $form.find('[name="postalCode"]').val() };

    history.replaceState({}, '', location.protocol + '//' + location.host + location.pathname
        + '?' + $.param(urlParams));

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
            $('.status-message').removeClass('d-none');
        }
    });
    return false;
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            if ($('.store-details-page-container').length === 1) {
                maps();
            }
            if ($('.js-store-locator').data('hasStores')) {
                maps();
            }
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').removeClass('d-none');
        }

        if ($('.near-by-instore-pickup-btn').length === 1) {
            maps();
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var findInStore = $('.in-store-pickup-checkbox').is(':checked');

                if ($('.near-by-instore-pickup-btn').length === 1) {
                    findInStore = true;
                }

                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    findInStore: findInStore
                };

                history.replaceState({}, '', location.protocol + '//' + location.host + location.pathname
                    + '?' + $.param(urlParams));

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            });
        });
    },

    search: function () {
        var pickUpTextHandler = function () {
            if ($('.store-locator-input').val().length > 0) {
                $('.pick-up-text').addClass('d-none');
            } else {
                $('.pick-up-text').removeClass('d-none');
            }
        };

        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            $('.store-locator-content-asset-container').addClass('d-none');
            $('.bopis-callout-slot').removeClass('d-flex').addClass('d-none');
            $('.results-card-container').removeClass('d-none');
            $('.pickupLocations-results-container').removeClass('d-none');
            $('.pickup-location-no-results-messaging').addClass('d-none');
            $('.distance-messaging').removeClass('text-danger');
            maps();
            search($(this));
            pickUpTextHandler();
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            $('.store-locator-content-asset-container').addClass('d-none');
            $('.map-container').addClass('d-lg-block');
            $('.store-locator-no-results').addClass('d-none');
            $('.bopis-callout-slot').removeClass('d-flex').addClass('d-none');
            $('.results-card-container').removeClass('d-none');
            $('.pickupLocations-results-container').removeClass('d-none');
            $('.pickup-location-no-results-messaging').addClass('d-none');
            $('.distance-messaging').removeClass('text-danger');
            maps();
            search($(this));
            pickUpTextHandler();
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var findInStore = $('.in-store-pickup-checkbox').is(':checked');
            $('.status-message').removeClass('d-none');

            if ($('.near-by-instore-pickup-btn').length === 1) {
                findInStore = true;
            }

            var urlParams = {};


            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode,
                    findInStore: findInStore
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long,
                    findInStore: findInStore
                };
            }

            history.replaceState({}, '', location.protocol + '//' + location.host + location.pathname
                + '?' + $.param(urlParams));

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.status-message').removeClass('d-none');

                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    },
    toggleMobileResults: function () {
        $('.mobile-toggle-btn').on('click', function () {
            if ($(this).hasClass('list-btn')) {
                $(this).removeClass('unselected');
                $('.map-btn').addClass('unselected');
                $('.map-container').addClass('d-none');
                $('.results.striped').removeClass('d-none');
            } else {
                maps();
                $(this).removeClass('unselected');
                $('.list-btn').addClass('unselected');
                $('.map-container').removeClass('d-none');
                $('.results.striped').addClass('d-none');
            }
        });
    },
    viewMapOnMobileStoreDetailsPage: function () {
        $('.view-map-btn').on('click', function () {
            $('.jumbotron.map-canvas.js-store-details-map').detach().appendTo('.store-details-page-map-mobile');
            $('.store-details-page-map-mobile').removeClass('d-none');
            $('.store-details-page-details').addClass('pr-4');
            $('.store-details-page-details').removeClass('pr-4');
            $('html,body').animate({
                scrollTop: $('.store-details-page-map-mobile').offset().top
            },
            'slow');
        });


        $(window).on('resize', function () {
            $('.jumbotron.map-canvas.js-store-details-map').detach().appendTo('.store-details-page-map');
            $('.store-details-page-map-mobile').addClass('d-none');
            $('.store-details-page-details').removeClass('pr-4');
        });
    },
    setPickupLocation: function () {
        $('body').on('click', '.set-pickup-location', (function (e) {
            e.preventDefault();
            $.spinner().start();
            $('.favorite-store').addClass('d-none');
            $('.add-to-favorites').removeClass('d-none');
            $(this).addClass('d-none');
            $(this).next().removeClass('d-none');
            var url = $(this).data('action');

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.selected-store-container').empty();
                    $('.selected-store-container').append(data.storeResultsHtml);
                    $('.logged-in-menu-links .store-pickup-name').html(data.selectedStore.name);
                    if (data.selectedStore === '') {
                        $('.js-header-favorite-store').addClass('d-none');
                    } else {
                        $('.js-header-favorite-store').removeClass('d-none');
                        $('.js-header-favorite-store-name').text(data.selectedStore.name);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }));
    },
    startSearchOnHittingEnterButton: function () {
        $('.store-locator-input').on('keyup', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                $('.btn-storelocator-search').trigger('click');
            }
        });
    },
    storeSelectEvent: function () {
        $('.store-locator-container').on('click', '.js-store-select', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $self = $(this);
            var data = {
                storeName: $self.data('store_name'),
                storeID: $self.data('store_id')
            };

            $('body').trigger('event:StoreSelect', data);

            var href = $self.attr('href');
            var target = $self.attr('target') || '_self';
            window.open(href, target);
        });
    },
    backloadStoresWhenUsingLocation: function () {
        $(document).ready(function () {
            if ($('#store-postal-code').val() === 'Loading') {
                $('.detect-location').trigger('click');
                $('#store-postal-code').val('');
            }
        });
    }
};
